var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0424 5.96427C14.8453 4.67858 17.1547 4.67858 18.9576 5.96427C21.2873 7.61891 24.407 10.112 25.9871 11.3977C26.6252 11.9232 27 12.7393 27 13.6226V23.3268C27 25.9093 25.1059 28 22.7661 28H9.23389C6.89411 28 5 25.9093 5 23.3268V13.7679C5 12.907 5.35451 12.1021 5.97238 11.5766C7.54236 10.2574 10.6925 7.64127 13.0424 5.96427Z",
    stroke: "#B3B3B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7829 19H14.2152C13.0104 19 12.0391 20.1387 12.0391 21.5511V28H19.9591V21.5511C19.9591 20.1387 18.9877 19 17.7829 19Z",
    stroke: "#B3B3B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.20563fe7e2ada07fcf8366a1cb6d24f6.svg";
export { ForwardRef as ReactComponent };